export default {
    bannerText: "Project Plan",
    embeddedBoardTitle: "Sign up for free to gain full access to all features",
    embeddedBoardLink: "https://view.monday.com/3565981122-91f9221ceff3c454e3b37cbc72ea5d33?r=use1"
};
